export { default as WhatsNextSection } from "./whatNextSection";
